export const Keys = {
  tab: 'Tab',
  enter: 'Enter',
  esc: 'Escape',
  space: 'Space',
  shift: 'Shift',
  up: 'ArrowUp',
  down: 'ArrowDown',
};
